import MainPage from "components/the-buzz-theme/page/main";
import { ResolvedType } from "interfaces";
import {
  CategoryToAncestorsCategoryConnection,
  RootQueryToPostConnection,
} from "interfaces/wordpress";

import {
  getRecentPosts,
  getStickyPosts,
  getCategoryTabs,
  POST_COUNT,
  setPostCount,
  getStickyPostIDs,
  getFirstCategoryTabPostIds,
  getTags,
} from "lib/api";
import { SOCIAL_IMAGE_FALLBACK } from "lib/constants";
import { GetStaticPropsContext } from "next";
import * as React from "react";
import { NextSeo } from "next-seo";
import { getLocale } from "lib/localization";
import { FontsCircular } from "lib/scripts";
import { SupportedLanguage } from "lib/lexemes/supported-languages";

export type Props = {
  stickyPosts: RootQueryToPostConnection;
  categoryTabs: CategoryToAncestorsCategoryConnection;
  recentPosts: ResolvedType<typeof getRecentPosts>;
  recentPostsTotal?: number;
  tags?:
    | undefined
    | {
        name: string;
        count: number;
        slug: string;
      }[];
};

export default function IndexPage(props: Props) {
  return (
    <>
      <NextSeo
        title={"Bumble Buzz"}
        openGraph={{
          title: "Bumble Buzz",
          images: [
            {
              url: SOCIAL_IMAGE_FALLBACK,
            },
          ],
        }}
      />
      <FontsCircular />

      <MainPage
        stickyPosts={props.stickyPosts}
        categoryTabs={props.categoryTabs}
        recentPosts={props.recentPosts}
        recentPostsTotal={props.recentPostsTotal}
        tags={props.tags}
      />
    </>
  );
}

export const getStaticProps = async function getStaticProps({
  params,
  preview = false,
}: GetStaticPropsContext<{ lang: SupportedLanguage }>) {
  const lang = getLocale(undefined, params);

  const [stickyPostIDs, firstCategoryTabPostIDs] = await Promise.all([
    getStickyPostIDs(),
    getFirstCategoryTabPostIds(),
  ]);

  const excludedPostIds = [stickyPostIDs, firstCategoryTabPostIDs].flat() || [];

  const [{ stickyPosts }, { categoryTabs }, recentPosts, { tags }] =
    await Promise.all([
      getStickyPosts(),
      getCategoryTabs({ notIn: stickyPostIDs }),
      getRecentPosts(POST_COUNT, null, null, null, excludedPostIds),
      getTags(),
    ]);

  return {
    props: {
      lang,
      preview,
      stickyPosts,
      categoryTabs,
      recentPosts,
      recentPostsTotal: setPostCount(recentPosts.total),
      tags,
    },
    revalidate: 20,
  };
};
